import Cookies from 'js-cookie';
const url=process.env.REACT_APP_ENV==="production"?"https://hrmanagement.zorvas.com":process.env.REACT_APP_API_URL
 



async function KnowledgeTestCompletionCheck(){

   try{
      const response=await fetch(`${url}/api/knowledgetest/testCompletionCheck?userid=${Cookies.get('id')}`,{method:'GET'});
      if(response.ok)
      {
         const data=await response.json();
         console.log('qa',data);
         return data;
      }
       return `Issue with reponse!`
   }
   catch(err)
   {
      return `Network error ${err}`
   }
}

async function ReceiveQuestionsMultiDomain(roleName,domainsParam,experience){
   try{
      const response=await fetch(`${url}/api/knowledgetest/fetchquestionsmultidomain?userid=${Cookies.get('id')}&role_name=${encodeURIComponent(roleName)}&domain_names=${encodeURIComponent(domainsParam)}&experience=${encodeURIComponent(experience)}`,
      {method:'GET'});
      if(response.ok)
      {
         const data=await response.json();
         // console.log(data);
         return data;
      }
       return `Issue with reponse!`
   }
   catch(err)
   {
      return `Network error ${err}`
   }
}
export async function CheckTestStatus() {
  try {
    const response = await fetch(`${url}/api/knowledgetest/checkstatus?userid=${Cookies.get('id')}`, {
      method: 'GET'
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    }
    return { completed: false };
  }
  catch (err) {
    return { completed: false };
  }
}

async function ReceiveQuestions(){
   try{
      const response=await fetch(`${url}/api/knowledgetest/fetchquestions?userid=${Cookies.get('id')}`,{method:'GET'});
      if(response.ok)
      {
         const data=await response.json();
         // console.log(data);
         return data;
      }
       return `Issue with reponse!`
   }
   catch(err)
   {
      return `Network error ${err}`
   }
}
async function SubmitAnswer(data)
{
   try{
      const response=await fetch(`${url}/api/knowledgetest/submitanswer`,{body:JSON.stringify(data),method:'POST',headers:{'Content-Type':'application/json'}});
      if(response.ok)
         {
             const data=await response.json();
             console.log('submitanswer',data);
             return data;
         }
   }
   catch(error)
   {
      console.log("error",error);
       return error;
   }
}
async function ReceiveScore(data){

   const body=data;
   try{
      const response=await fetch(`${url}/api/knowledgetest/mcqscore`,{method:'POST',
         headers:{'Content-Type':'application/json'},
         body:JSON.stringify(body)});
      if(response.ok)
      {
         const data=await response.json();
         // console.log("score",data);
         return data;
      }
       return `Issue with score reponse!`
   }
   catch(err)
   {
      return `Network error ${err}`
   }
}
async function ReceiveTestScore(userid){

   try{
      const response=await fetch(`${url}/api/knowledgetest/overalltestscore?userid=${userid}`,{method:'GET',
         headers:{'Content-Type':'application/json'}});

      if(response.ok)
      {
         const data=await response.json();
         // console.log("score",data);
         return data;
      }
       return `Issue with score reponse!`
   }
   catch(err)
   {
      return `Network error ${err}`
   }
}



export {ReceiveQuestions,
         ReceiveScore,
         SubmitAnswer,
         ReceiveTestScore,
         KnowledgeTestCompletionCheck,
         ReceiveQuestionsMultiDomain
      }